import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconFolderCheckLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 18V6v5.617-.463V18Zm.308 1.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 0 1-.525-1.283V6.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525H9.05c.241 0 .473.047.695.14.223.094.416.223.58.387L11.798 6.5h7.894c.505 0 .933.175 1.283.525.35.35.525.778.525 1.283v2.928a.726.726 0 0 1-.215.535.726.726 0 0 1-.535.215.726.726 0 0 1-.535-.215.726.726 0 0 1-.215-.535V8.308a.3.3 0 0 0-.087-.222.3.3 0 0 0-.22-.086h-7.76c-.241 0-.473-.047-.695-.14a1.79 1.79 0 0 1-.58-.387L9.27 6.087A.281.281 0 0 0 9.06 6H4.308a.3.3 0 0 0-.221.087.3.3 0 0 0-.087.22v11.385a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087h6.016a.73.73 0 0 1 .535.215.725.725 0 0 1 .215.535.725.725 0 0 1-.215.535.726.726 0 0 1-.535.215H4.308Zm12.63-1.212-.719-.719a.557.557 0 0 0-.414-.174.595.595 0 0 0-.424.19.58.58 0 0 0-.187.419.58.58 0 0 0 .187.419l.925.925a.87.87 0 0 0 .633.271c.24 0 .451-.09.632-.271l2.356-2.34a.595.595 0 0 0 0-.854.552.552 0 0 0-.42-.179.638.638 0 0 0-.419.179l-2.15 2.134Zm.716-4.942c1.249 0 2.31.438 3.186 1.314.876.875 1.314 1.937 1.314 3.186 0 1.249-.438 2.311-1.314 3.187-.875.875-1.937 1.313-3.186 1.313-1.249 0-2.311-.438-3.187-1.313-.875-.876-1.313-1.938-1.313-3.187 0-1.249.438-2.31 1.313-3.186.876-.876 1.938-1.314 3.187-1.314Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconFolderCheckLine;
